import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {Container, Row, Col, Button} from 'reactstrap';
import {getMyInvoices} from './invoiceComponentBlockSlice';
import {showAppLoader} from '../../Shared/Loader/LoaderSlice';
import InvoiceDataComponent from './InvoiceDataComponent';
import LocalLoader from '../../Shared/LocalLoader/LocalLoader';
import gaParams from '../../../utilities/analytics/constants';
import {gaEvent} from '../../../utilities/analytics/tracking';
import ServiceBoxTiny from '../../Shared/ServiceBox/ServiceBoxTiny/ServiceBoxTiny';
import {ActionType, ActionGroupType} from '../CoreProductActionsBlock/CoreProductEnum';
import {getActionsByTypes} from '../CoreProductActionsBlock/CoreProductActionsSlice';
import {prepareSameWindowUrl} from '../../../utilities/StringHelpers/StringHelpers';
import PopUp from '../../Shared/Popup/PopUp';
import InvoicesActionsPopUp from './InvoicesActionsPopUp';

const InvoicesComponentBlock = (props) => {
  const {isMobile} = props;
  const {firstLoading, invoicesList, loading, error, previousButton, absolutelyNew, visibleBlock} = props.data;
  const [collapse, setCollapse] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  let colorIndex = 0;
  let actionsArray = [];
  const defaultActionsList = props.iContent?.invoicesOptionsList?.expandedValue;
  const [defaultArray, setDefaultArray] = useState(defaultActionsList);

  useEffect(() => {
    props.getMyInvoices();
  }, [props.isFullAuthenticated]);



  useEffect(() => {
    if (!loading && !error)
      gaEvent(
        gaParams.SELF_CARE_INVOICES_BLOCK_LOADED.category,
        gaParams.SELF_CARE_INVOICES_BLOCK_LOADED.eventType,
        props.data.invoicesList.length
      );
  }, [loading]);


  useEffect(() => {
    async function fetchData() {
      if (props.data.activeInvoiceURL?.trim() && props.iContent.invoiceOnlineIFrameURL?.value?.trim()) {
        props.showAppLoader();
        var content = await props.context.loadContentByPath(props.iContent.invoiceOnlineIFrameURL.value.trim());
        props.context.navigateTo(content);
      }
    }
    fetchData();
  }, [props.data.activeInvoiceURL]);

  useEffect(() => {
    const getActionsAsync = async () => {
      try { // in case there is no actions => catch exception
        actionsArray = await getActionsByTypes([ActionType.INVOICES], ActionGroupType.ACTIONS);
        if (props.organizationData?.organizationCodeList?.value?.length > 0) {
          //update actions list array by organization approved actions
          let intersection = [];
          for (let i = 0; i < defaultActionsList.length; i++) {
            for (let j = 0; j < actionsArray.length; j++) {
              if (defaultActionsList[i].actionName.value == actionsArray[j].actionName) {
                intersection.push(defaultActionsList[i]);
                continue;
              }
            }
          }

          setDefaultArray(intersection);
        } else {
          setDefaultArray(defaultActionsList);
        }
      } catch (error) {
        console.log(error);
      }
    };

    if (props.isActionsReady) {
      getActionsAsync();
    }
  }, [props.isActionsReady]);

  function closePopUp() {
    document.getElementsByTagName('body')[0].classList.remove('modal-open');
    setShowPopUp(false);
  }



  return visibleBlock ? (
    <div className='headTitleBlock'>
      <Col xs={12} className={`${isMobile ? 'pl-0 pr-0' : ''}`}>
        <Row className='titles-row justify-content-md-center invoices-headline'>
          <Col className='text-right pr-0 invoices-block-title'>
            <div className='titleMainDiv'>
              <span className='titleMain'>החשבוניות שלך</span>
              {isMobile && (
                <div className='mobileAllOp'>
                  <div
                    onClick={() => {
                      setShowPopUp(true);
                    }}>
                    לביצוע פעולות
                  </div>
                </div>
              )}
            </div>
          </Col>
          {showPopUp && isMobile && (
            <PopUp showPopUp={showPopUp} onClose={() => closePopUp()}>
              <InvoicesActionsPopUp isPopUp={true} badgeText={'חדש'} defaultArray={defaultArray} context={props.context} />
            </PopUp>
          )}

          {!isMobile && (
            <div className='myOptions'>
              {defaultArray != null &&
                defaultArray.length > 0 &&
                defaultArray.map((option, index) => {
                  return (
                    <ServiceBoxTiny
                      isHaveBadge={option.isNew?.value}
                      backgroundImage={option.actionIcon?.value}
                      badgeText={'חדש'}
                      actionName={option.actionName?.value}
                      callback={() => prepareSameWindowUrl(option.actionUrl?.value, props.context)}></ServiceBoxTiny>
                  );
                })}
            </div>
          )}
        </Row>
      </Col>
      {!loading ? (
        <div className='justify-content-md-center'>
          {invoicesList.length > 0 && !error ? (
            invoicesList.map((bill, index) => {
              if (!bill.isNewCustomer && bill.invoices.length > 0) {
                colorIndex++;
                return (
                  <InvoiceDataComponent
                    accountType={bill.accountType}
                    key={bill.banPsId}
                    id={bill.banPsId}
                    billCycle={bill.billCycle}
                    invoices={bill.invoices}
                    isDisconnected={bill.isDisconnected}
                    collapse={collapse}
                    style={colorIndex & 1 ? 'purple' : 'lightPurple'}
                    isMobile={isMobile}
                  />
                );
              } else {
                if (absolutelyNew) {
                  return (
                    <InvoiceDataComponent
                      accountType={bill.accountType}
                      key={bill.banPsId}
                      invoices={null}
                      collapse={true}
                      style={null}
                      isMobile={isMobile}
                      error={error}
                      isNewCustomer={bill.isNewCustomer}
                      billCycle={bill.billCycle}
                    />
                  );
                }
              }
            })
          ) : (
            <InvoiceDataComponent invoices={null} collapse={true} isMobile={isMobile} error={error} style={'purple'} />
          )}
        </div>
      ) : (
        <div className='justify-content-center loader-block'>
          <Col xs={12}>
            <LocalLoader />
          </Col>
        </div>
      )}
    </div>
  ) : null;
};

const mapStateToProps = (state) => {
  return {
    data: state.invoices,
    isFullAuthenticated: state.authentication.loginData.isFullAuthenticated,
    isActionsReady: state.coreProductActions?.isActionsReady,
    organizationData: state.welcomeBlock?.organizationState,
  };
};

const mapDispatchToProps = {
  getMyInvoices,
  showAppLoader,
  getActionsByTypes,
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoicesComponentBlock);
